import { useEffect, useState } from 'react';
import { fetchFiniquitoEmployers, getFiniquitosEmployersTableId } from '../services/finiquitosApi';

export function useFiniquitosEmployers({ enabled }) {
  const [employers, setEmployers] = useState([]);
  const [loadingEmployers, setLoadingEmployers] = useState(false);
  const [employersError, setEmployersError] = useState('');
  const tableId = getFiniquitosEmployersTableId();

  useEffect(() => {
    if (!enabled) {
      setEmployers([]);
      setLoadingEmployers(false);
      setEmployersError('');
      return undefined;
    }

    if (!tableId) {
      setEmployers([]);
      setLoadingEmployers(false);
      setEmployersError('');
      return undefined;
    }

    let ignore = false;

    async function loadEmployers() {
      try {
        setLoadingEmployers(true);
        setEmployersError('');
        const records = await fetchFiniquitoEmployers({ tableId });
        if (!ignore) {
          setEmployers(records);
        }
      } catch (error) {
        if (!ignore) {
          setEmployers([]);
          setEmployersError(error.message || 'No fue posible cargar empleadores.');
        }
      } finally {
        if (!ignore) {
          setLoadingEmployers(false);
        }
      }
    }

    loadEmployers();
    return () => {
      ignore = true;
    };
  }, [enabled, tableId]);

  return {
    employers,
    loadingEmployers,
    employersError
  };
}
